import {
  SetAuthenticated,
  setCurrentWorkspace,
  setLoadingMe,
  setUserEmail,
  setUserToken,
  setVerify,
  setVerifyEmailUser,
} from '../redux/actions/authActions';
import { acceptWorkspaceInvitationsBatch } from '../API/services/companyService';
import { getLocalStorageWorkspace } from '../utils/workspaceUtils';

const setWorkspace = async (dispatch) => {
  await acceptWorkspaceInvitationsBatch();
  const saveWorkspaceSelect = getLocalStorageWorkspace();

  dispatch(setCurrentWorkspace(saveWorkspaceSelect?.id));
};

export const handleAuthResult = async ({
  result,
  dispatch,
  roles,
  setCollapsed,
  isPublicDashboard = false,
}) => {
  const audience = process.env.RAZZLE_RUNTIME_AUTH_ZERO_AUDIENCE;
  localStorage.setItem('id_token', true);

  if (!result || !result.access_token) return;

  const payload = result.id_token;

  localStorage.setItem('token', result.access_token);
  localStorage.setItem('roles', JSON.stringify(payload[`${audience}roles`] || []));

  dispatch(SetAuthenticated(true));
  dispatch(setVerify(payload[`${audience}email_verified`]));
  dispatch(setVerifyEmailUser(payload[`${audience}email`]));
  dispatch(setUserToken(result.access_token));
  dispatch(setUserEmail(payload[`${audience}email`]));

  if (
    localStorage.getItem('isOnboarding') === null &&
    payload[`${audience}roles`]?.includes(roles?.TESTSCREENINGSPARTNER)
  ) {
    setCollapsed(false);
    localStorage.setItem('isOnboarding', 'false');
  }

  if (window.location.pathname !== '/error' && !isPublicDashboard) {
    await setWorkspace(dispatch);
  }

  dispatch(setLoadingMe(false));
};
